import React, { useState } from "react";
import { HiCheckCircle, HiXCircle, HiChevronDown } from 'react-icons/hi';

const KitchenCleaningInfo = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        { 
            question: "Is this service applicable for all types of kitchens?", 
            answer: "Yes, our team handles everything from compact city apartment kitchens to large estate culinary spaces. We adapt our techniques for modular, traditional, and industrial kitchen designs." 
        },
        { 
            question: "Do I need to be present during the cleaning?", 
            answer: "While not mandatory, we recommend a brief walkthrough at the start to discuss any specific areas of concern or delicate surfaces." 
        },
        { 
            question: "How long does a deep kitchen clean typically take?", 
            answer: "Depending on the size and initial condition, a premium deep clean takes between 2 to 4 hours to ensure every surface meets our hygiene standards." 
        }
    ];

    const included = [
        "Surface Sterilization - Antibacterial treatment for all countertops",
        "Exterior Appliance Polish - Refrigerator, oven, and microwave facades",
        "Deep Degreasing - Backsplash and chimney exterior cleaning",
        "Cabinet Restoration - Removal of sticky residues from faces and handles",
        "Sanitary Sink Wash - Deep scrubbing and disinfectant treatment",
        "Floor Rejuvenation - specialized grease-cutting mopping"
    ];

    const excluded = [
        "Deep cleaning of the internal mechanics of appliances",
        "Heavy-duty internal range hood filter replacement",
        "Removal of permanent scorch marks on stovetops"
    ];

    return (
        <div className="space-y-12">
            {/* Included / Excluded Grid */}
            <div className="grid md:grid-cols-2 gap-8">
                <div className="card-premium p-8 border-l-4 border-l-primary">
                    <h3 className="text-xl font-black text-foreground mb-6 uppercase tracking-widest text-sm text-primary">Inclusions</h3>
                    <ul className="space-y-4">
                        {included.map((item, i) => (
                            <li key={i} className="flex gap-4 text-sm text-muted-foreground leading-relaxed">
                                <HiCheckCircle className="text-primary shrink-0" size={20} />
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="card-premium p-8 border-l-4 border-l-destructive/30">
                    <h3 className="text-xl font-black text-foreground mb-6 uppercase tracking-widest text-sm text-muted-foreground">Exclusions</h3>
                    <ul className="space-y-4">
                        {excluded.map((item, i) => (
                            <li key={i} className="flex gap-4 text-sm text-muted-foreground leading-relaxed">
                                <HiXCircle className="text-destructive opacity-50 shrink-0" size={20} />
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* Premium FAQ Section */}
            <div className="space-y-6">
                <h3 className="text-2xl font-black text-foreground">Expert Guidance</h3>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div 
                            key={index}
                            className="group rounded-2xl border border-border bg-white overflow-hidden transition-all hover:border-primary/30"
                        >
                            <button 
                                onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                                className="w-full px-8 py-6 flex items-center justify-between text-left"
                            >
                                <span className="font-bold text-foreground group-hover:text-primary transition-colors">{faq.question}</span>
                                <HiChevronDown 
                                    className={`text-muted-foreground transition-transform duration-300 ${activeIndex === index ? 'rotate-180' : ''}`} 
                                    size={20} 
                                />
                            </button>
                            <div 
                                className={`px-8 transition-all duration-300 ease-in-out ${activeIndex === index ? 'pb-8 max-h-40 opacity-100' : 'max-h-0 opacity-0'}`}
                            >
                                <p className="text-sm text-muted-foreground leading-relaxed">
                                    {faq.answer}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default KitchenCleaningInfo;
